var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.13388 0.366117C1.64573 -0.122039 0.854272 -0.122039 0.366117 0.366117C-0.122039 0.854272 -0.122039 1.64573 0.366117 2.13388L5.23223 7L0.366117 11.8661C-0.122039 12.3543 -0.122039 13.1457 0.366117 13.6339C0.854272 14.122 1.64573 14.122 2.13388 13.6339L7 8.76777L11.8661 13.6339C12.3543 14.122 13.1457 14.122 13.6339 13.6339C14.122 13.1457 14.122 12.3543 13.6339 11.8661L8.76777 7L13.6339 2.13388C14.122 1.64573 14.122 0.854272 13.6339 0.366117C13.1457 -0.122039 12.3543 -0.122039 11.8661 0.366117L7 5.23223L2.13388 0.366117Z",
    fill: "rgba(0, 0, 0, 0.38)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2d2a70ce4f9f5d7eebec4f30e3bf35b4.svg";
export { ForwardRef as ReactComponent };